import { createContext } from "react";

interface Project {
    id: string;
    [key: string]: any;
    // Add other fields as needed
}

export interface ProjectContextType {
    project: Project | null;
    setProject: (project: Project | null) => void;
}

export const ProjectContext = createContext<ProjectContextType | undefined>(undefined);
